import { combineReducers } from 'redux';
import background from './background';

const backgroundReducer = combineReducers({
	background,
});

export default backgroundReducer;
